import PujaView from "../../Views/Puja/PujaView";
import ParentView from "../../Views/PrarentView/ParentView";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useRef, useCallback } from "react";
import { getPaginatedActivePujas } from "../../store/actions/pujaAction";
import { LOCALSTORAGE_KEY, packageType } from "../../utils/Constants";
import { getBenefitsList } from "../../store/actions/templeAction";
import { pageReady } from "../../store/slices/pageViewSlice";
import { getDeviceTypeFromUserAgent } from "../../utils/analyics/analyticsHelper";
function PujaScreen() {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { cartInfo } = useSelector((state: any) => state.cart);
  const [allPujaList, setAllPujaList] = useState<any>([]);
  const loadingRef = useRef<boolean>(false);
  const lasDocRef = useRef<any>(null);
  const didMount = useRef<any>(false);

  const { benefitsList } = useSelector((state: any) => state.temple);

  useEffect(() => {
    dispatch(getBenefitsList())
      .then((res: any) => {})
      .catch((err: any) => {
        console.log("Error:", err);
      });
  }, [dispatch]);

  useEffect(() => {
    try {
      if (!didMount.current) {
        fetchData(null)
          .then(() => {
            loadingRef.current = false;
          })
          .catch(() => {
            loadingRef.current = false;
          });
        didMount.current = true;
      }
    } catch (error) {}
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const trackPageViewEvent = (allPujaList: any) => {
      if (!allPujaList) return;
      dispatch(
        pageReady({
          User_ID:
            JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY.USERINFO) ?? "{}")
              ?.id ?? "Guest User",
          Page_Type: "Puja Listing",
          Listing_Type: "Puja Listing",
          Total_Items_Shown: allPujaList?.length ?? 0,
          Device_Type: getDeviceTypeFromUserAgent(),
        }),
      );
    };

    trackPageViewEvent(allPujaList);
  }, [allPujaList]);

  const handleScroll = async () => {
    const scrollPosition =
      window.innerHeight + document.documentElement.scrollTop;
    const threshold = document.documentElement.offsetHeight - 1000;

    if (
      scrollPosition >= threshold &&
      !loadingRef.current &&
      lasDocRef.current
    ) {
      fetchData(lasDocRef.current)
        .then(() => {
          loadingRef.current = false;
        })
        .catch(() => {
          loadingRef.current = false;
        });
    }
  };

  // Pagination fetch
  const fetchData = useCallback(
    async (lastDoc: any = null) => {
      if (loadingRef.current) return;
      loadingRef.current = true;
      try {
        const res: any = await dispatch(getPaginatedActivePujas(lastDoc));
        if (res?.data?.length && lasDocRef.current?.id !== res?.lastDoc?.id) {
          setAllPujaList((prev: any) => [...prev, ...res.data]);
          lasDocRef.current = res.lastDoc;
        }
      } finally {
        loadingRef.current = false;
      }
    },
    [dispatch, loadingRef.current],
  );

  const onClickAddPuja = (_pujaDetails: any) => {
    const pujaDetails = _pujaDetails?.pujaDetails ?? null;
    if (pujaDetails?.type === packageType.puja) {
      navigate(`/pujaPackage?pujaNameKey=${pujaDetails?.pujaNameKey}`);
    } else {
      navigate(
        `/templePujaInfo?templeNameKey=${pujaDetails.nameKey}&pujaNameKey=${pujaDetails?.pujaNameKey}`,
      );
    }
  };

  const selectTemple = (templeDetails: any) => {
    navigate("/templePujaList/" + templeDetails.orgId);
  };

  const navigateToGlobalSearch = () => {
    navigate("/globalSearch");
  };
  return (
    <ParentView>
      <PujaView
        allPujaList={allPujaList}
        selectTemple={selectTemple}
        cartDetails={cartInfo}
        onClickAddPuja={onClickAddPuja}
        navigateToGlobalSearch={navigateToGlobalSearch}
        benefitsList={benefitsList}
      />
    </ParentView>
  );
}

export default PujaScreen;
